import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { detectLanguage, saveLanguage, updateHtmlLang, extractLanguageCode } from '../utils/languageUtils';

// English translations
const commonEN = require('./locales/en/common.json');
const navEN = require('./locales/en/nav.json');
const heroEN = require('./locales/en/hero.json');
const productsEN = require('./locales/en/products.json');
const cartEN = require('./locales/en/cart.json');
const checkoutEN = require('./locales/en/checkout.json');
const profileEN = require('./locales/en/profile.json');
const authEN = require('./locales/en/auth.json');
const footerEN = require('./locales/en/footer.json');
const searchEN = require('./locales/en/search.json');
const bidsEN = require('./locales/en/bids.json');
const conversationsEN = require('./locales/en/conversations.json');
const privacyEN = require('./locales/en/privacy.json');
const aboutEN = require('./locales/en/about.json');
const howtoEN = require('./locales/en/howto.json');
const feedbackEN = require('./locales/en/feedback.json');
const splashEN = require('./locales/en/splash.json');

// French translations
const commonFR = require('./locales/fr/common.json');
const navFR = require('./locales/fr/nav.json');
const heroFR = require('./locales/fr/hero.json');
const productsFR = require('./locales/fr/products.json');
const cartFR = require('./locales/fr/cart.json');
const checkoutFR = require('./locales/fr/checkout.json');
const profileFR = require('./locales/fr/profile.json');
const authFR = require('./locales/fr/auth.json');
const footerFR = require('./locales/fr/footer.json');
const searchFR = require('./locales/fr/search.json');
const bidsFR = require('./locales/fr/bids.json');
const conversationsFR = require('./locales/fr/conversations.json');
const privacyFR = require('./locales/fr/privacy.json');
const aboutFR = require('./locales/fr/about.json');
const howtoFR = require('./locales/fr/howto.json');
const feedbackFR = require('./locales/fr/feedback.json');
const splashFR = require('./locales/fr/splash.json');

const resources = {
  en: {
    common: commonEN,
    nav: navEN,
    hero: heroEN,
    products: productsEN,
    cart: cartEN,
    checkout: checkoutEN,
    profile: profileEN,
    auth: authEN,
    footer: footerEN,
    search: searchEN,
    bids: bidsEN,
    conversations: conversationsEN,
    privacy: privacyEN,
    about: aboutEN,
    howto: howtoEN,
    feedback: feedbackEN,
    splash: splashEN,
  },
  fr: {
    common: commonFR,
    nav: navFR,
    hero: heroFR,
    products: productsFR,
    cart: cartFR,
    checkout: checkoutFR,
    profile: profileFR,
    auth: authFR,
    footer: footerFR,
    search: searchFR,
    bids: bidsFR,
    conversations: conversationsFR,
    privacy: privacyFR,
    about: aboutFR,
    howto: howtoFR,
    feedback: feedbackFR,
    splash: splashFR,
  },
};

// Detect initial language
const initialLanguage = detectLanguage();

// Update HTML lang attribute immediately
updateHtmlLang(initialLanguage);

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: initialLanguage || 'fr', // Use detected language or default to French
    fallbackLng: 'fr', // Fallback to French if translation missing
    defaultNS: 'common',
    ns: ['common', 'nav', 'hero', 'products', 'cart', 'checkout', 'profile', 'auth', 'footer', 'search', 'bids', 'conversations', 'privacy', 'about', 'howto', 'feedback', 'splash'],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'cookie'],
      caches: ['localStorage', 'cookie'],
      lookupLocalStorage: 'i18nextLng',
      lookupCookie: 'i18nextLng',
      cookieMinutes: 525600, // 1 year
      // Don't use navigator language - always default to French
    },
  });

// Update HTML lang when language changes
i18n.on('languageChanged', (lng) => {
  const code = extractLanguageCode(lng);
  updateHtmlLang(code);
  saveLanguage(code);
});

export default i18n;

